import React from 'react';

const HamburgerMenuIcon = ({ width = 20, height = 20, color = '#ffffff' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.6667 6.16667H3.33333C2.875 6.16667 2.5 5.79167 2.5 5.33333C2.5 4.875 2.875 4.5 3.33333 4.5H16.6667C17.125 4.5 17.5 4.875 17.5 5.33333C17.5 5.79167 17.125 6.16667 16.6667 6.16667ZM3.33333 10.6667H16.6667C17.125 10.6667 17.5 10.2917 17.5 9.83333C17.5 9.375 17.125 9 16.6667 9H3.33333C2.875 9 2.5 9.375 2.5 9.83333C2.5 10.2917 2.875 10.6667 3.33333 10.6667ZM3.33333 15H16.6667C17.125 15 17.5 14.625 17.5 14.1667C17.5 13.7083 17.125 13.3333 16.6667 13.3333H3.33333C2.875 13.3333 2.5 13.7083 2.5 14.1667C2.5 14.625 2.875 15 3.33333 15Z"
      fill={color}
    />
  </svg>
);

export default HamburgerMenuIcon;
